import { Component, OnDestroy } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Editor, toHTML } from 'ngx-editor';
import { Subscription } from 'rxjs';

@Component({
  standalone: false,
  selector: 'app-ckcontrol',
  templateUrl: './ckcontrol.component.html',
  styleUrls: ['./ckcontrol.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: CKControlComponent,
    },
  ],
})
export class CKControlComponent implements ControlValueAccessor, OnDestroy {
  /**
   *
   */
  subscription: Subscription = new Subscription();
  constructor() {
    this.editor = new Editor({});
    this.subscription.add(
      this.editor.valueChanges.subscribe((values) => {
        this.text = toHTML(values);
        this.onChange(this.text);
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  editor: Editor;
  text: string;

  disabled: boolean;

  touched: boolean;

  textMode = false;

  onTouched: () => void;

  onChange: (data) => void;

  ckOptions = {
    embed_provider: '//ckeditor.iframe.ly/api/oembed?url={url}&callback={callback}',
    removePlugins: 'elementspath',
    resize_enabled: false,
    toolbar: [
      {
        name: 'basicstyles',
        items: [
          'Removeformat',
          'Maximize',
          'Source',
          'Underline',
          'Bold',
          'Italic',
          'NumberedList',
          'BulletedList',
          '-',
          'Outdent',
          'Indent',
          '-',
          'Blockquote',
          'CreateDiv',
          '-',
          'Styles',
          'JustifyLeft',
          'JustifyCenter',
          'JustifyRight',
          'JustifyBlock',
          '-',
          'BidiLtr',
          'BidiRtl',
          'Link',
          'Unlink',
          'Anchor',
          'Table',
          'HorizontalRule',
          'Iframe',
          'MediaEmbed',
          'Oembed',
          'Image',
          'Emoji',
        ],
      },
    ],
    uiColor: '#99000',
  };

  toolbar: any = [
    // default value
    ['bold', 'italic'],
    ['underline', 'strike'],
    ['code', 'blockquote'],
    ['ordered_list', 'bullet_list'],
    [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
    ['link', 'image'],
    // or, set options for link:
    // [{ link: { showOpenInNewTab: false } }, 'image'],
    ['text_color', 'background_color'],
    ['align_left', 'align_center', 'align_right', 'align_justify'],
    ['horizontal_rule', 'format_clear', 'indent', 'outdent'],
    ['superscript', 'subscript'],
    ['undo', 'redo'],
  ];

  onLocalChange(_$event: string) {
    this.onChange(this.text);
  }

  writeValue(text: string): void {
    this.text = text;
  }

  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }
}
